import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    // Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    Stack,
    FormHelperText,
    ListItemButton,
    List
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

import { useNavigate } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import LocationSelector from "../../selector/LocationSelector";

import SearchRetailMembers from "../../dialog/SearchRetailMembers";
import SearchItems from "../../dialog/SearchItems";
import SearchDocuments from "../../dialog/SearchDocuments";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useTranslations } from '../../../hooks/useTranslations';

import { CommonIcons, icons } from "../../common/CommonIcons";
import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments"
import { useDocumentAdjustments } from "../../../hooks/state/useDocumentAdjustments";

import { calculateSummaryRows } from "../../../utils/dataSchema";

import {
    loadFromDocumentTypes,
    LoadFromDocuments
} from "../../dialog/LoadFromDocuments";

import {
    validationSchema,
    initialValues,
    initialRowValues,
} from "../../../schema/documents/retailPrescriptionSchema"

import { useStateRetailPrescription } from "../../../hooks/state/loadFrom/documents/useStateRetailPrescription";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function NewRetailPrescription({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate()

    const { authData, getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.retailPrescription.id)

    const { setSystemLoading } = useAppContextFeatures();
    // const { isLoading, list: getPaymentMethods } = usePaymentMethods();
    const { isLoading: isLoadingCreate, create } = useDocuments({ 
        documentType: documentTypes.retailPrescription, 
        targetType: targetTypes.retailPrescription
    })

    const [preview, setPreview] = useState(false)

    // const [ paymentMethods, setPaymentMethods ] = useState([])

    // const [ selectLocationIds, setSelectLocationIds ] = useState()

    const { updateFormikState, getFormikDependencyStates } = useStateRetailPrescription()

    // const [searchDocumentConfig, setSearchDocumentConfig] = useState({
    //     show: false,
    //     documentType: [documentTypes.retailPrescription],
    //     presetDocumentType: documentTypes.retailPrescription,
    //     keyword: ""
    // })

    const [loadDocumentConfig, setLoadDocumentConfig] = useState({
        show: false,
        documentId: loadFromDocumentTypes.retailPrescription.id,
        documentType: loadFromDocumentTypes.retailPrescription.type,
        keyword: ""
    })

    const availableLocations = getAvailableLocations();

    const onSubmit = async (currentValues) => {

        // console.log('curren tVal', currentValues);
        // console.log('auth data', authData)

        const document = {
            doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
            doc_remark: currentValues.remark,
        }

        const props = {
            location_id: currentValues.locationId,
            retail_outlet_id: currentValues.retailOutletBranchId,
            note: currentValues.note,
        }

        const profiles = {
            member: {
                user_id: currentValues.memberUserId
            }
        }

        // const amounts = {
        //     // discount_percentage : "", /* percentage */
        //     discount_amount : currentValues.discount, 
        // }

        let items = [];

        currentValues.rows.map(item => {
            items.push({
                id: item?.itemId,
                code: item?.code,
                name: item?.name,
                description: item?.description,
                qty: item?.qty,
                uom_lbl: item?.uomName,
                uom: item?.uomId,
                price: item?.price
            })
            return false;
        })

        let adjustments = getPayloadSubmitCreate()

        try {

            let data = {
                document,
                profiles,
                // amounts,
                props,
                items,
                adjustments,
                ...getFormikDependencyStates({ values })
            }

            const response = await create({ data });

            // console.log('response', response)

            promptMessage(true, `${response?.message}`)

            navigate(getRoute("documents/retailPrescriptions"))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue } = formik;

    const {
        getAmount,
        calculateSummaryRows,
        updateTaxPreviewOpen,
        RenderDocumentSummary,
        RenderDocumentTaxPreview,
        getPayloadSubmitCreate
    } = useDocumentAdjustments({
        formik,
        disableTax: true,
        documentType: documentTypes.retailPrescription,
        handlePreviewChange: (val) => {
            // console.log('current open', val)
            setPreview(val)
        }
    })

    useEffect(() => {

        calculateSummaryValues();

    }, [values])

    useEffect(() => {

        const currentLocationIds = getLocationIds();

        // setSelectLocationIds(currentLocationIds)

        if (currentLocationIds.length > 0) {
            // console.log('currentLocationIds', currentLocationIds, availableLocations)

            // get the location information
            const loc = availableLocations.filter(item => item.id === currentLocationIds[0])

            if (loc.length) {
                setFieldValue("locationId", loc[0].id)
                setFieldValue("locationName", loc[0].location_name)
            }
        }

    }, [getLocationIds])

    useEffect(() => {

        // need to get from auth access for the parent retailer user id
        setFieldValue(`retailerUserId`, authData?.profile?.parent_user_id)

    }, [])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayText: t("loadFrom"),
                onClick: () => {

                    // check the location is selected - valid
                    if (validateLocationSelection() === false) {
                        promptMessage(false, t(`pleaseSelectAnyLocation`))
                        return false;
                    }

                    setLoadDocumentConfig(prev => ({ ...prev, show: true }))

                    return true;

                }
            })
        }

        return props
    }

    const calculateSummaryValues = () => {

        if (!values) return false;

        try {
            // const { totalAmount } = 
            calculateSummaryRows({
                // formikValues: values,
                // setFieldValue,
                handleValueRow: ({ subTotal, index }) => {
                    setFieldValue(`rows.${index}.subtotal`, subTotal.toFixed(2))
                },
            })

            // setFieldValue(`totalamount`, totalAmount.toFixed(2))

        } catch (error) {
            promptMessage(false, `Error in summary calculation : ${error}`)
        }

        return true;

    }

    const validateLocationSelection = () => {
        const selected = getLocationIds()
        return selected && selected.length === 1
    }

    const handleAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1Row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const updateStateFromSearchDocument = (props) => {

        try {

            // check the location is selected - valid
            if (validateLocationSelection() === false) {
                promptMessage(false, t(`pleaseSelectAnyLocation`))
                return false;
            }

            updateFormikState({
                data: props?.data,
                routeType,
                setFieldValue,
            })


        } catch (error) {
            promptMessage(false, `Load failed : ${error}`)
        }

        return true;
    }

    const RenderRows = ({ values, errors, touched, handleChange, setFieldValue }) => {

        const rows = values?.rows;

        return (
            <Box
            >
                <Box
                >
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <Grid key={index} item xs={12} sm={12} md={12}>

                                    <Grid container spacing={0.5} >

                                        <Grid item xs={12} sm={12} md={0.5} alignSelf={"center"}>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
                                            >
                                                <CommonIcons name={icons.remove} />
                                            </IconButton>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3.5}>

                                            <SearchItems
                                                id={`rows.${index}.name`}
                                                handleOnCancel={() => { }}
                                                handleOnSearchChange={(event) => {
                                                    setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                                }}
                                                handleOnSelect={({ id, item }) => {
                                                    // console.log('id', id, item)
                                                    setFieldValue(`rows.${index}.itemId`, item?.id)
                                                    setFieldValue(`rows.${index}.name`, item?.item_name)
                                                    setFieldValue(`rows.${index}.description`, item?.description)
                                                    setFieldValue(`rows.${index}.code`, item?.code)
                                                    setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                                    setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                                    setFieldValue(`rows.${index}.qty`, 1)
                                                    setFieldValue(`rows.${index}.price`, item?.uom_price)
                                                }}
                                                textProps={{
                                                    disabled: true,
                                                    value: itemValues?.name ? itemValues.name : "",
                                                    error: Boolean(itemErrors?.name),
                                                    helperText: itemErrors?.name
                                                }}
                                            />

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                disabled
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.uomName`}
                                                label={t("uom")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.uomName ? itemValues.uomName : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.uomName)}
                                                helperText={itemErrors?.uomName}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3.5}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.description`}
                                                label={t("description")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.description ? itemValues.description : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.description)}
                                                helperText={itemErrors?.description}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "center"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.qty`}
                                                label={t("qty")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.qty ? itemValues.qty : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.qty`, event.target.value);
                                                    // handleDisplayRowChange({ index, qty: event.target.value});
                                                }}
                                                error={Boolean(itemErrors?.qty)}
                                                helperText={itemErrors?.qty}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.price`}
                                                label={t("price")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.price ? itemValues.price : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.price`, event.target.value);
                                                    // handleDisplayRowChange({ index, price: event.target.value});
                                                }}
                                                error={Boolean(itemErrors?.price)}
                                                helperText={itemErrors?.price}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1.5}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                disabled
                                                name={`rows.${index}.subtotal`}
                                                label={t("subTotal")}
                                                value={itemValues?.subtotal ? itemValues.subtotal : "0.00"}
                                                type="text"
                                                variant="outlined"
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Box>

                <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid>

                {
                    RenderSummaryRow({ values, errors, touched, handleChange, setFieldValue })
                }

            </Box>
        )
    }

    // const RenderSummaryRow = ({ values, errors, touched, handleChange, setFieldValue }) => {
    //     return (
    //         <Grid item xs={12} sm={12} md={12}>

    //             <Grid container spacing={0.5}>

    //                 <Grid item xs={12} sm={12} md={4}>

    //                     <Button
    //                         variant="outlined"
    //                         sx={{ mt: 2 }}
    //                         fullWidth
    //                         startIcon={<CommonIcons name={icons.add} />}
    //                         onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
    //                     >
    //                         {t('addItem')}
    //                     </Button>

    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={5}>
    //                     <></>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         inputProps={{
    //                             style: {
    //                                 textAlign: "right"
    //                             }
    //                         }}

    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}

    //                         margin="normal"
    //                         size="small"
    //                         fullWidth
    //                         name={"discount.amount"}
    //                         label={t("discount")}
    //                         type="text"
    //                         variant="outlined"
    //                         value={values?.discount?.amount ? values.discount.amount : "0.00"}
    //                         onChange={(event) => {
    //                             setFieldValue(`discount.amount`, event.target.value);
    //                         }}
    //                         error={Boolean(errors?.discount?.amount)}
    //                         helperText={errors?.discount?.amount}
    //                     />
    //                 </Grid>

    //             </Grid>

    //             <Grid container spacing={0.5}>

    //                 <Grid item xs={12} sm={12} md={9}>
    //                     <></>
    //                 </Grid>

    //                 {/* <Grid item xs={12} sm={12} md={1}>
    //                     <Typography sx={{ mt: 2, mp: 2}}>
    //                     Discount
    //                     </Typography>
    //                 </Grid> */}

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         inputProps={{
    //                             style: {
    //                                 textAlign: "right"
    //                             }
    //                         }}
    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}
    //                         margin="normal"
    //                         size="small"
    //                         disabled
    //                         fullWidth
    //                         name={"totalamount"}
    //                         label={t("totalAmount")}
    //                         type="text"
    //                         variant="outlined"
    //                         value={values?.totalamount ? values.totalamount : "0.00"}
    //                     // onChange={handleChange}
    //                     // error={touched.total && Boolean(errors.total)}
    //                     // helperText={touched.total && errors.total}
    //                     />
    //                 </Grid>

    //             </Grid>

    //         </Grid>
    //     )
    // }

    // Discount (Adjustments Hook)

    const RenderSummaryRow = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt: 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t("addItem")}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={3}>
                        <></>
                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>

                        {
                            RenderDocumentSummary()
                        }

                    </Grid>

                </Grid>

            </Grid>
        )
    }

    const RenderFormProfile = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <StyledCard sx={{ mb: 1 }}>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`profile`)}
                            subTitle={t(`relatedProfilesAttachedToDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>

                        <SearchRetailMembers
                            id={"searchRetailMembers"}
                            ownerId={values?.retailerUserId ? values.retailerUserId : ""}
                            handleOnCancel={() => {

                            }}
                            handleOnSearchChange={(event) => {
                                setFieldValue('memberDisplay', `${event.target.value}`)
                            }}
                            handleOnSelect={({ id, item }) => {
                                setFieldValue('memberUserId', item?.user_id)
                                setFieldValue('memberDisplay', `${item?.firstname} ${item?.lastname}`)
                            }}
                            textProps={{
                                disabled: true,
                                value: values?.memberDisplay,
                                error: Boolean(errors?.memberUserId),
                                helperText: errors?.memberUserId,
                            }}
                        />

                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderFormLocation = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`location`)}
                            subTitle={t(`relatedWarehouseLocationToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={10.5}>
                        <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label={t("location")}
                            type="text"
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        />
                    </Grid>
                    <Grid item md={1.5}>
                        <IconButton
                            color="primary"
                            sx={{
                                // pt: 0
                            }}
                            onClick={() => {
                                setLocationIds([])
                            }}
                        >
                            <StyledIcon
                                sx={{
                                    width: 25,
                                    height: 25,
                                    m: 0,
                                    p: 0
                                }}
                            >
                                <CommonIcons name={icons.edit} />
                            </StyledIcon>
                        </IconButton>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"note"}
                                    label={t("privateNote")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.note}
                                    onChange={handleChange}
                                    error={touched.note && Boolean(errors.note)}
                                    helperText={touched.note && errors.note}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        return (
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormProfile({ values, errors, touched, handleChange, setFieldValue })
                        }
                        {
                            RenderFormLocation({ values, errors, touched, handleChange, setFieldValue })
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {
                            RenderFormDocument({ values, errors, touched, handleChange, setFieldValue })
                        }
                    </Grid>

                </Grid>
                <StyledCard sx={{ mt: 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`items`)}
                                subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows({ values, errors, touched, handleChange, setFieldValue })
                            }

                            {/* <FieldArray
                                    name="rows"
                                    render={(arrayHelpers) => {
                                        
                                        return RenderRow({ values, errors, touched, handleChange, setFieldValue, arrayHelpers})
                                    
                                    }}
                                /> */}
                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoadingCreate}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>

            </form>
        )
    }

    const RenderAll = () => {
        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: t("selectOnly1Location"),
                        description: t("youHaveToSelectAnyoneOfTheWarehouseLocationToProceed")
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        // console.log('selected', selected)

                        setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationName`, selected[0].location_name)

                        // need to specify full fil for api params (location - branch id)
                        setFieldValue(`retailOutletBranchId`, selected[0].branch_id)

                    }}
                />
            )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newRetailPrescription })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newRetailPrescription")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("retailPrescriptions"),
                        props: {
                            // underline: "hover",
                            href: getRoute('documents/retailPrescriptions')
                        }
                    },
                    {
                        displayText: t("newRetailPrescription"),
                        props: {
                            // disabled: true,
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {JSON.stringify(errors)}

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            }

            {
                loadDocumentConfig?.show &&

                <LoadFromDocuments
                    fromDocumentId={loadDocumentConfig?.documentId}
                    fromDocumentType={loadDocumentConfig?.documentType}
                    show={loadDocumentConfig?.show}
                    filledSearchKeyword={loadDocumentConfig?.keyword}
                    handleOnCancel={() => {
                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSelect={(props) => {

                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))

                        // load the data into the state
                        updateStateFromSearchDocument(props)

                    }}
                />
            }

        </Box>
    )
}